module.exports = __webpack_public_path__ + "img/icon-plus-hold.012580f5.svg";